import { useState } from 'react';

import { AppRoutes } from '~/core/router/routes';

export function useSidebarState() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [collapsedGroups, setCollapsedGroups] = useState<Record<string, boolean>>({});
  const [activeTabGroupId, setActiveTabGroupId] = useState<string | null>(null);
  const [activeTabGroupItemId, setActiveTabGroupItemId] = useState<string | null>(null);

  const toggleGroup = (groupId: string) => {
    setCollapsedGroups((prev) => ({
      ...prev,
      [groupId]: !prev[groupId],
    }));
  };

  const handleTabGroupItemClick = (groupId: string, item: any) => {
    setActiveTabGroupId(groupId);
    setActiveTabGroupItemId(item.id);
  };

  return {
    isDrawerOpen,
    setIsDrawerOpen,
    isSidebarOpen,
    setIsSidebarOpen,
    collapsedGroups,
    activeTabGroupId,
    activeTabGroupItemId,
    toggleGroup,
    handleTabGroupItemClick,
  };
}
export function handleOrganizationChange(
  value: string,
  organizations: any[],
  currentOrganization: any,
  userEmail: string
) {
  const selectedOrg = organizations.find((org) => org.id === value) || organizations[0];

  if (selectedOrg.id === currentOrganization?.id) return;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/';

  const actionInput = document.createElement('input');
  actionInput.type = 'hidden';
  actionInput.name = 'actionType';
  actionInput.value = 'logout';
  form.appendChild(actionInput);

  const orgInput = document.createElement('input');
  orgInput.type = 'hidden';
  orgInput.name = 'selectedOrganization';
  orgInput.value = JSON.stringify({
    id: selectedOrg.id,
    name: selectedOrg.name,
  });
  form.appendChild(orgInput);

  const emailInput = document.createElement('input');
  emailInput.type = 'hidden';
  emailInput.name = 'userEmail';
  emailInput.value = userEmail;
  form.appendChild(emailInput);

  document.body.appendChild(form);
  form.submit();
}
export function getTranslatedLabel(key: string, i18n: any, t: any): string {
  if (!key) return '';

  if (key.includes('.')) {
    const [namespace, translationKey] = key.split('.');
    return i18n.exists(`${namespace}:${translationKey}`)
      ? t(`${namespace}:${translationKey}`)
      : key;
  }

  const namespaces = ['userManagement', 'common', 'auth', 'projectManagement', 'farmerReport'];
  for (const namespace of namespaces) {
    if (i18n.exists(`${namespace}:${key}`)) {
      return t(`${namespace}:${key}`);
    }
  }

  return key;
}

// Extracted helper for checking route active state
export function isRouteActive(location: any, routePath: string, routeKey: string): boolean {
  if (location.pathname === routePath || location.pathname.startsWith(`${routePath}/`)) {
    return true;
  }

  const currentRoute = Object.values(AppRoutes).find(
    (route: any) =>
      location.pathname === route.path || location.pathname.startsWith(`${route.path}/`)
  );

  // Special case for FARMER_REPORT_REGION_MANAGER
  // Since this route redirects to FARMER_REPORT and its children, mark it as active when on any farmer report route
  if (routeKey === 'FARMER_REPORT_REGION_MANAGER') {
    return location.pathname.startsWith('/farmer-report');
  }

  return !!(currentRoute && currentRoute.parent === routeKey);
}
